
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SiteType } from 'enums/SiteType';
import { Model, ModelProperty } from 'models/Model';


export class SiteDtoModel extends Model<SiteDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'pointerName', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'installInfo', type: 'any', isHidden: true },
		{ name: 'type', type: 'SiteType' }
	];
	[key: string]: any;
	
	public pointerName: string;
	public companyId?: string;
	public productPlanId?: string;
	public installInfo?: any;
	public type: SiteType;
    
	constructor(){
		super();
		this.pointerName = '';
		this.companyId = undefined;
		this.productPlanId = undefined;
		this.installInfo = undefined;
		this.type = 0;
		
	}
	getProperties(){
		return SiteDtoModel.classProperties;
	}
}

